<template>
  <div class="mode">
    <vue-feather
      v-show="mixLayout == 'light-only'"
      type="moon"
      @click="customizeMixLayout('dark-only')"
    ></vue-feather>
    <vue-feather
      v-show="mixLayout == 'dark-only'"
      type="sun"
      @click="customizeMixLayout('light-only')"
    ></vue-feather>
  </div>
</template>

<script>
  export default {
    name: 'Mode',
    data() {
      return {
        mixLayout: 'light-only',
      };
    },
    methods: {
      customizeMixLayout(val) {
        this.mixLayout = val;
        this.$store.dispatch('layout/setLayout', {class:val});
      },
    },
  };
</script>
